const salt: string = '0123456789abcdefghijklmnopqrstuvwxyz0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ012345678~!@#$%^&*(){}[]_-+.';
/**
 * 字符串存储加密
 * @param str 需要加密的字符串
 * @returns 
 */
export function toBtoa(str: string) {
  if (typeof window.btoa === 'function') {
    const strArr: string[] = [...str];
    const result: string[] = [];
    strArr.forEach(item => {
      const randomNum1 = Math.floor(Math.random() * 100);
      const randomNum2 = Math.floor(Math.random() * 100);
      const randomNum3 = Math.floor(Math.random() * 100);
      result.push(item, salt[randomNum1], salt[randomNum2], salt[randomNum3]);
    });
    try {
      return window.btoa(result.join(''));
    } catch {
      return str;
    }
  }
  return str;
}
/**
 * 字符串存储解密
 * @param str 需要解密的字符串
 * @returns 
 */
export function toAtob(str: string) {
  if (typeof window.atob === 'function') {
    try {
      const aaa = window.atob(str);
      const strArr: string[] = [...aaa];
      const result: string[] = [];
      strArr.forEach((item, index) => {
        if (index % 4 === 0) {
          result.push(item);
        }
      });
      return result.join('');
    } catch {
      return '';
    }
  }
  return str;
}
/**
 * 设置localStorage值
 * @param itemName 键名
 * @param itemValue 键值
 */
export function setLocalStorageItem(itemName: string, itemValue: any) {
  try {
    const formatValue = typeof itemValue === 'string' ? itemValue : JSON.stringify(itemValue);
    const password = toBtoa(formatValue);
    window.localStorage.setItem(itemName, password);
  } catch {
    console.error(`localStorage值${itemName}设置失败，请检查键值格式是否正确`);
  }
}
/**
 * 获取localStorage值
 * @param itemName 键名
 * @param renderObject 键值是否需要转换成对象
 * @returns 
 */
export function getLocalStorageItem(itemName: string, renderObject?: boolean) {
  const password = window.localStorage.getItem(itemName);
  if (password) {
    const value = toAtob(password);
    if (renderObject) {
      try {
        return JSON.parse(value);
      } catch {
        return null;
      }
    }
    return value;
  }
  return password;
}
